import _ from 'underscore';

const schema = {
  scenario: [
    {
      name: 'expLogger',
      value: 'expLogger',
      setting: {},
      activity: [
        {
          name: 'sendLog',
          value: 'SendLog',
        },
      ],
    },
  ],
};

let expLoggerScenario = null;

function getScenario(instrumentation) {
  if (_.isEmpty(expLoggerScenario)) {
    instrumentation.addScenario(schema);
    expLoggerScenario = instrumentation.expLogger.create();
  }

  return expLoggerScenario;
}

/**
 * Create instrumentation activity for logging
 * @param {Object} instrumentation - exsiting instrumentation instance
 * @returns {Object} instrumentation activity instance
 */
export function createActivity(instrumentation) {
  const scenario = getScenario(instrumentation);

  return scenario.sendLog.create();
}
